import React from 'react';
import '../../component-styles/Proposal-UI.css';

export default function ConfirmModal({ isOpen, title, message, confirmLabel, onConfirm, onCancel, destructive }) {
  if (!isOpen) return null;

  const confirmBtnStyle = destructive
    ? {
        background: '#dc2626',
        color: '#fff',
        padding: '10px 22px',
        borderRadius: '999px',
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        minWidth: '110px',
      }
    : undefined;

  return (
    <div className="proposal-lock-overlay" onClick={onCancel}>
      <div className="proposal-lock-modal" onClick={(e) => e.stopPropagation()}>
        {title && <h3>{title}</h3>}
        <p>{message}</p>
        <div className="proposal-lock-actions">
          <button className="if-btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button
            className={destructive ? undefined : 'if-btn-primary'}
            style={confirmBtnStyle}
            onClick={onConfirm}
          >
            {confirmLabel || 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}
